import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import theme from '@ep/theme';

const NavLink = styled(Link)`
  flex-grow: 1;
  font-family: ${theme.typography.lightFont};
  font-size: 1.1rem;
  font-weight: 650;
  @media (max-width: 1100px) {
    font-size: 1rem;
  }
  line-height: 4rem;
  color: ${theme.colors.darkBlue};
  text-align: center;
  text-decoration: none;
  transition: ${theme.transitions.create(['color'])};
  :hover {
    transition: 0.25s;
    text-decoration: none;
    color: ${theme.colors.skyBlue} !important;
  }
`;

export default NavLink;
